import { ListingCate } from '@/page-commons/listingBySlug'

export enum LISTING_TYPE {
  IBUYER_BROKERED = 'ibuyer_brokered',
  IBUYER_DIRECT = 'ibuyer_direct',
  ODA_BROKERED = 'oda_brokered',
  ODA_DIRECT = 'oda_direct',
  THIRD_PARTY = 'third_party',
}

enum INVENTORY {
  IBUYER = 'ibuyer',
  ODA = 'oda',
  THIRD_PARTY = 'third_party',
}

enum SALES_PIPELINE {
  BROKERED = 'brokered',
  DIRECT = 'direct',
}

export const getListingType = (listing: ListingCate) => {
  const { inventory, salesPipeline } = listing.detail
  if (inventory === INVENTORY.IBUYER) {
    return salesPipeline === SALES_PIPELINE.DIRECT ? LISTING_TYPE.IBUYER_DIRECT : LISTING_TYPE.IBUYER_BROKERED
  }
  if (inventory === INVENTORY.ODA) {
    return salesPipeline === SALES_PIPELINE.DIRECT ? LISTING_TYPE.ODA_DIRECT : LISTING_TYPE.ODA_BROKERED
  }
  if (inventory === INVENTORY.THIRD_PARTY && salesPipeline === null) return LISTING_TYPE.THIRD_PARTY
}

export const isDirectSales = (listing: ListingCate) =>
  [LISTING_TYPE.IBUYER_DIRECT, LISTING_TYPE.ODA_DIRECT].includes(getListingType(listing))
export const isOwnedByCasavo = (listing: ListingCate) => {
  return [
    LISTING_TYPE.IBUYER_DIRECT,
    LISTING_TYPE.IBUYER_BROKERED,
    LISTING_TYPE.ODA_BROKERED,
    LISTING_TYPE.ODA_DIRECT,
  ].includes(getListingType(listing))
}
export const isThirdParty = (listing: ListingCate) => getListingType(listing) === LISTING_TYPE.THIRD_PARTY
